const normalizeList = (value) => {
  if (Array.isArray(value)) return value;
  if (value && typeof value === "object") return Object.values(value);
  return [];
};

const sameFile = (item, file) => {
  if (!item || !file) return false;

  if (item.url && file.url) return item.url === file.url;
  if (item.id && file.id) return item.id === file.id;
  if (item.key && file.key) return item.key === file.key;

  return false;
};

export function removeInvoiceFromFreightState({
  formFields = [],
  freightOrigin = {},
  stopId,
  stopIndex,
  file,
} = {}) {
  const nextFormFields = formFields.map((field, index) => {
    const matchById = stopId && field.id === stopId;
    const matchByIndex = !stopId && index === stopIndex;
    if (!matchById && !matchByIndex) return field;

    return {
      ...field,
      invoices: normalizeList(field.invoices).filter(
        (item) => !sameFile(item, file),
      ),
    };
  });

  const nextFreightInvoices = normalizeList(freightOrigin?.invoices).filter(
    (item) => {
      if (!sameFile(item, file)) return true;
      if (!stopId) return false;
      return String(item.stoppingPointId || "") !== String(stopId);
    },
  );

  return {
    nextFormFields,
    nextFreightInvoices,
  };
}
